import React, { useState, useEffect } from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText, Button } from '@mui/material';
import { BASE_URL } from '../../utils/config';
import SendIcon from '@mui/icons-material/Send';
import Loading from "../loading";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Tooltip from '@mui/material/Tooltip';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

const McxTable = ({ Record, Record1, heading, updateSLchange, RecordColor }) => {
  console.log(`Record for ${heading}`, Record);

  const columns = [
    { id: "Remove", label: "Remove", minWidth: 40 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Commodity Name', minWidth: 160 },
    { id: 'datetime', label: 'Date Time', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'lot', label: 'LotSize', minWidth: 80 },
    { id: 'margin', label: 'Margin', minWidth: 90},
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
    { id: 'IndexStopLoss', label: 'IndexStopLoss', minWidth: 80 },
  ];
  const columns1 = [
    { id: "Remove", label: "Remove", minWidth: 40 },
    { id: "S.No", label: "S.No", minWidth: 40 },
    { id: 'SignalType', label: 'Commodity Name', minWidth: 160 },
    { id: 'datetime', label: 'Date Time', minWidth: 110 },
    { id: 'PriceAtSignal', label: 'PriceAtSignal', minWidth: 90 },
    { id: 'Current_cmp', label: 'CurrentCMP', minWidth: 110 },
    { id: 'SignalStopLoss', label: 'SignalStopLoss', minWidth: 70 },
    { id: 'lot', label: 'LotSize', minWidth: 80 },
    { id: 'margin', label: 'Margin', minWidth: 90},
    { id: 'SignalFinal', label: 'SignalFinal', minWidth: 100 },
    { id: 'SignalDT', label: 'SignalDT', minWidth: 110 },
    { id: 'LastCheckedDT', label: 'LastCheckedDT', minWidth: 110 },
    { id: 'HighAfterSignal', label: 'HA Signal', minWidth: 70 },
    { id: 'HighDT', label: 'HighDT', minWidth: 110 },
    { id: 'LowAfterSignal', label: 'LA Signal', minWidth: 90 },
    { id: 'LowDT', label: 'LowDT', minWidth: 110 },
    { id: 'symbol', label: 'Symbol', minWidth: 100 },
    { id: 'close', label: 'Close', minWidth: 70 },
    { id: 'open', label: 'Open', minWidth: 70 },
    { id: 'high', label: 'High', minWidth: 70 },
    { id: 'low', label: 'Low', minWidth: 70 },
    { id: 'volume', label: 'Volume', minWidth: 80 },
    { id: 'Expiry', label: 'Expiry', minWidth: 110 },
    { id: 'InstrumentToken', label: 'Ins Token', minWidth: 100 },
    { id: 'IndexStopLoss', label: 'IndexStopLoss', minWidth: 80 },
    { id: 'close_sma12', label: 'C_sma12', minWidth: 90 },
    { id: 'close_sma26', label: 'C_sma26', minWidth: 90 },
    { id: 'close_sma200', label: 'C_sma200', minWidth: 90 },
  ];
  const [authdata, setAuthData] = useState({
    username: '',
    password: ''
  });
  const [cmp, setCMP] = useState('')
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(25);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [DelSelectedRecord, setDelSelectedRecord] = useState({});
  const [authenticationOpen, setAuthenticationOpen] = useState(false);
  const [SLEditOpen, setSLEditOpen] = useState(false);
  const [LotEditOpen, setLotEditOpen] = useState(false);
  const [MarginEditOpen, setMarginEditOpen] = useState(false);
  const [RemoveAlert, SetRemoveAlert] = useState(false);
  const [BookPorL, setBookPorL] = useState('')
  const [newsl, setNewSL] = useState('');
  const [showInvalidPasswordAlert, setShowInvalidPasswordAlert] =
    useState(false);
  const [Errorshow, setErrorShow] = useState(false);
  const [Errormessage, setErrorMessage] = useState('');
  const [checked, setChecked] = useState(true);
  const [newLot,setNewLot]=useState('');
  const [newMargin,setNewMargin]=useState('');
  const [screenerOldData, setScreenerOldData] = useState([]);
  const [futureOldData, setFutureOldData] = useState([]);
  const [optionOldData, setOptionOldData] = useState([]);
  const [deliveryOldData, setDeliveryOldData] = useState([]);
  const [hniOldData, setHniOldData] = useState([]);
  const [newRecords, setNewRecords] = useState([]);
  const [AlertMessage, setAlertMessage] = useState("");
  const [showAlert, setshowAlert] = useState(false);
  const [commentrymessage, setCommentryMessage] = useState()
  const [bookLot,setBookLot]=useState(1);
  const passwordRegex =
    /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+[\]{};:<>?]{8,}$/;


  useEffect(() => {
    console.log("inserting new record", Record.length);
    console.log("inserting new record", Record);
    if (heading === 'ScreenerTab') {
      if (Record.length > 0) {

        const newRecord = Record.filter(record => !screenerOldData.some(d => d.id === record.id));

        console.log("newRecords", newRecord);

        setNewRecords(newRecord)
        setScreenerOldData(Record)
      }
    }
    if (heading === 'FutureTab') {

      if (Record.length > 0) {

        const newRecord = Record.filter(record => !futureOldData.some(d => d.id === record.id));

        console.log("newRecords", newRecord);

        setNewRecords(newRecord)
        setFutureOldData(Record)
      }
    }
    if (heading === 'OptionTab') {

      if (Record.length > 0) {

        const newRecord = Record.filter(record => !optionOldData.some(d => d.id === record.id));

        console.log("newRecords", newRecord);

        setNewRecords(newRecord)
        setOptionOldData(Record)
      }
    }
    if (heading === 'DeliveryTab') {

      if (Record.length > 0) {

        const newRecord = Record.filter(record => !deliveryOldData.some(d => d.id === record.id));

        console.log("newRecords", newRecord);

        setNewRecords(newRecord)
        setDeliveryOldData(Record)
      }
    }
    if (heading === 'HNITab') {

      if (Record.length > 0) {

        const newRecord = Record.filter(record => !hniOldData.some(d => d.id === record.id));

        console.log("newRecords", newRecord);

        setNewRecords(newRecord)
        setHniOldData(Record)
      }
    }


  }, [Record]);


  // handle close dialog for book profit or loss
  const handleClose = () => {
    setCommentryMessage('');
    setOpenDialog(false);
    setBookLot(1);
    setChecked(true)
    setErrorMessage('');
    setErrorShow(false);
  };

  // handle change page for pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    let startindex = newPage * rowsPerPage;
    console.log("startindex", startindex)
    let endindex = Math.min(startindex + rowsPerPage, Record.length)
    console.log("endindex", endindex)
    setStartIndex(startindex);
    setEndIndex(endindex)

  };

  // handle change rows per page for pagination
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setEndIndex(+event.target.value);
    setStartIndex(0);
    setPage(0);
  };

  // handle format date time for date time column
  const formatDateTime = (row) => {

    // console.log("row.datetime",row.datetime)

    let date = new Date(row.datetime);
    // console.log("timeDate",date)
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  }

  // handle expiry date time for expiry column
  const formatExpiry = (row) => {



    let date = new Date(row.Expiry);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // Format the date and time
    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;

    //  console.log(formattedDate);
    return formattedDate
  }

  // handle api to fetch cmp price
  const hyperLinkStockName = async (row) => {
    console.log("rowData", row);
    setSelectedRecord(row);
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/getcmpdashboard/${row.InstrumentToken}/stockinstoken/futuretoken`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();
      console.log("res", res);

      if (res.success === true) {
        console.log("auth pass");

        if (!res.data) {
          throw new Error("CMP data is missing.");
        }

        setCMP(res.data);
        let value;

        if (row.SignalFinal === 'SELL') {
          value = row.PriceAtSignal - res.data;
        } else {
          value = res.data - row.PriceAtSignal;
        }

        value = value.toFixed(2);
        setBookPorL(value);

        console.log("print bookPorL", value);
        setOpenDialog(true);
      } else {
        console.error("CMP not found.");
        setAlertMessage(`Error: ${res.message}`);
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage('');
        }, 1500);
      }
    } catch (error) {
      console.error("Error fetching CMP data:", error.message);
      setAlertMessage(`Failed to fetch CMP data. Please try again.${error.message}");`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage('');
      }, 1500);
    } finally {
      setLoading(false);
    }
  };

  // handle open dialog for authentication
  const handleStockLossChange = (row) => {
    console.log("row Data", row);
    setSelectedRecord(row);
    setNewSL(row.SignalStopLoss.toFixed(2));
    setAuthenticationOpen(true);
  }

  // handle open dialog for lot size
  const handlelotOpenDialog = (row) => {
    console.log("row Data", row);
    setSelectedRecord(row);
    setNewLot(row.lot)
    setLotEditOpen(true);
 
  }

  // handle open dialog for margin
  const handleMarginOpenDialog = (row) => {
    console.log("row Data", row);
    setSelectedRecord(row);
    setNewMargin(row.lot)
    setMarginEditOpen(true);
 
  }


  // handle lot change input
  const handlelotChange = (e) => {
    let value = e.target.value
   
    if (/^\d*$/.test(value)) {
      setNewLot(value);
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("Llot hold 2point value")
    }
  }

  // handle margin change input
  const handleMarginChange = (e) => {
    let value = e.target.value
   
    if (/^\d*$/.test(value)) {
      setNewMargin(value);
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("Margin hold 2point value")
    }
  }

  // handle close dialog for lot size
  const handleLotClose = ()=>{
    setLotEditOpen(false)
  }

  // handle close dialog for margin
  const handleMarginClose = ()=>{
    setMarginEditOpen(false)
  }

  // handel submit lotsize
  const handleLotSubmit = (e) => {
    e.preventDefault();
    console.log("inside Lot handler", newLot);
    console.log("inside lot selected record", selectedRecord);

    if (!newLot || newLot <= 0) {
      setAlertMessage("Please enter a valid lot size greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      fetch(`${BASE_URL}/editMCXDashboardSL?id=${selectedRecord.id}&type=lotSize&sl=${newLot}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("Lot edit success");
            setLotEditOpen(false);
            updateSLchange();

            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            setLoading(false);
            setAlertMessage(`Error: ${res.message || "Failed to update lot size."}`);
            setshowAlert(true);
            setTimeout(() => {
              setshowAlert(false);
              setAlertMessage("");
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(false);
          setAlertMessage(`Error: ${error.message || "Failed to update lot size."}`);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 1500);
        });
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      setAlertMessage(`Error: ${error.message || "Failed to update lot size."}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
    }
  };

  // handle submit margin
  const handleMarginSubmit = (e) => {
    e.preventDefault();
    console.log("inside Margin handler", newMargin);
    console.log("inside Margin selected record", selectedRecord);

    if (!newMargin || newMargin <= 0) {
      setAlertMessage("Please enter a valid margin value greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      fetch(`${BASE_URL}/editMCXDashboardSL?id=${selectedRecord.id}&type=Margin&sl=${newMargin}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => res.json())
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("Margin edit success");
            setMarginEditOpen(false);
            updateSLchange();

            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            setLoading(false);
            setAlertMessage(res.message || "Failed to update margin.");
           
            setshowAlert(true);
            setTimeout(() => {
              setshowAlert(false);
              setAlertMessage("");
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setLoading(false);
          setAlertMessage(`Error: ${error.message || "Failed to update margin."}`);
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 1500);
        });
    } catch (error) {
      console.error("Error:", error);
      setLoading(false);
      setAlertMessage(`Error: ${error.message || "Failed to update margin."}`);
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
    }
  };

  
  // handle automate signal to send mcx table and 
  const handleRecordSend = (row) => {
    if (!row || !row.id) {
      setAlertMessage("Invalid record selected.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
      return;
    }

    setSelectedRecord(row);
    let value = 1;

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        setAlertMessage("User is not authenticated. Please log in again.");
      
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage("");
        }, 1500);
        return;
      }

      fetch(`${BASE_URL}/editMCXDashboardSL?id=${row.id}&type=RecordUP&sl=${value}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Error: ${res.statusText}`);
          }
          return res.json();
        })
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("Record UP Success.");
            updateSLchange();
          } else {
            setAlertMessage(res.message || "Failed to update record.");
            
            setshowAlert(true);
            setTimeout(() => {
              setshowAlert(false);
              setAlertMessage("");
            }, 1500);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setAlertMessage("An error occurred while updating the record.");
       
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 1500);
        });
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Internal Server Error.");
      
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 1500);
    }
  };

  // handle close authentication dialog
  const handleAuthenticationClose = () => {
    setAuthData({
      username: '',
      password: ''
    })
    setAuthenticationOpen(false)
  }

  // handle close stop loss edit dialog
  const handleSLEditClose = () => {
    setSLEditOpen(false)
  }


  // handle authentication submit
  const handleAuthSubmit = (e) => {
    e.preventDefault();
    console.log("inside auth handler");

    if (!authdata.username || !authdata.password) {
      setAlertMessage("Username and Password are required.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      return;
    }

    if (!passwordRegex.test(authdata.password)) {
      setShowInvalidPasswordAlert(true);
      setTimeout(() => {
        setShowInvalidPasswordAlert(false);
      }, 2000);
      return;
    }

    setLoading(true);

    try {
      const body = JSON.stringify({ AuthDetails: authdata });
      fetch(`${BASE_URL}/authsledit`, {
        method: "POST",
        body,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Error: ${res.statusText}`);
          }
          return res.json();
        })
        .then((res) => {
          console.log("res", res);
          if (res.success) {
            console.log("auth pass");
            setAuthData({ username: "", password: "" });
            setAuthenticationOpen(false);
            setSLEditOpen(true);
          } else {
            setAlertMessage(res.message || "Authentication failed.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setAlertMessage("An error occurred during authentication.");
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 2000);
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Internal Server Error.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      setLoading(false);
    }
  };

  // handle submit stop loss
  const handleSLChangeSubmit = (e) => {
    e.preventDefault();
    console.log("inside sl handler", newsl);
    console.log("inside sl selected record", selectedRecord);

    if (!newsl || newsl <= 0) {
      setAlertMessage("Please enter a valid Stop Loss value greater than 0.");
   
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      return;
    }

    try {
      let loginuser = JSON.parse(localStorage.getItem("loginData"));
      if (!loginuser || !loginuser.user_id || !loginuser.token) {
        setAlertMessage("User is not authenticated. Please log in again.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
          setAlertMessage("");
        }, 2000);
        return;
      }

      fetch(`${BASE_URL}/editMCXDashboardSL?id=${selectedRecord.id}&type=SL&sl=${newsl}&modified_by=${loginuser.user_id}`, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${loginuser.token}`
        },
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Error: ${res.statusText}`);
          }
          return res.json();
        })
        .then((res) => {
          console.log("res", res);
          if (res.success === true) {
            console.log("SL edit success");
            setSLEditOpen(false);
            updateSLchange();

            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            setAlertMessage(res.message || "Failed to update Stop Loss.");
            setshowAlert(true);
            setTimeout(() => {
              setshowAlert(false);
              setAlertMessage("");
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setAlertMessage("An error occurred while updating the Stop Loss.");
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 2000);
        });
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Internal Server Error.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
    }
  };

  // handle authentication change input
  const handleAuthChange = (e) => {
    const { name, value } = e.target;
    setAuthData((prevState) => {
      const newState = {
        ...prevState,
        [name]: value
      };


      return newState;
    });
  };


  // handle book profit or loss submit

  const handleBookProfitOrLoss = (e, BookPorL) => {
    e.preventDefault();

    // Validate bookLot
    if (!bookLot || bookLot <= 0) {
      setAlertMessage("Please enter a valid Book Lot Size greater than 0.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      return;
    }

    // Validate selectedRecord
    if (!selectedRecord || !selectedRecord.id) {
      setAlertMessage("Invalid record selected.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      return;
    }

    // Validate cmp
    if (!cmp || cmp <= 0) {
      setAlertMessage("Invalid CMP value.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
      return;
    }

    try {
      const bodydata = JSON.stringify({
        BookPL: BookPorL,
        bookLot: bookLot,
        IsCommentary: checked,
        CommentryMessage: commentrymessage,
      });

      fetch(`${BASE_URL}/MCXbookprofitorcloseposition?id=${selectedRecord.id}&cmpPrice=${cmp}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodydata,
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error(`Error: ${res.statusText}`);
          }
          return res.json();
        })
        .then((res) => {
          if (res.success) {
            console.log("Book Profit or Close Position edit Success");
            setOpenDialog(false);
            updateSLchange();
            setCommentryMessage("");
            setTimeout(() => {
              setLoading(false);
            }, 2000);
          } else {
            throw new Error(res.message || "Failed to process the request.");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          setAlertMessage(error.message || "An error occurred.");
          setshowAlert(true);
          setTimeout(() => {
            setshowAlert(false);
            setAlertMessage("");
          }, 2000);
        });
    } catch (error) {
      console.error("Error:", error);
      setAlertMessage("Internal Server Error.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
        setAlertMessage("");
      }, 2000);
    }
  };

  // handle book lot change input
  const handleBooklotChange =(e)=>{
    e.preventDefault();
    let value = e.target.value

    if(value <= selectedRecord.lot){

      setBookLot(value)
    }else{
      setErrorMessage('Please Enter Less than Or Equal value to Available Lot.')
      setErrorShow(true)
      setTimeout(()=>{
        setErrorMessage('')
        setErrorShow(false)
      },1300)
    }
 
    

  }

  // handle sl change input
  const handleSLChange = (e) => {
    let value = e.target.value
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setNewSL(value)
    }
    else {
      setErrorMessage('Numeric input with 2 decimal places (0-9).')
      setErrorShow(true)
      setTimeout(() => {
        setErrorShow(false)
        setErrorMessage('')
      }, 3000)
      console.log("SL hold 2point value")
    }
  }


  // handle calculation of profit or loss
  const calCurrComp = (row) => {
    console.log("row of profit caluclation", row);
    let value
    let percentDifference

    if (row.SignalFinal === 'SELL') {
      value = row.PriceAtSignal - row.Current_cmp
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }
    if (row.SignalFinal === 'BUY') {
      value = row.Current_cmp - row.PriceAtSignal
      value = value.toFixed(2);
      percentDifference = ((value / row.PriceAtSignal) * 100).toFixed(2);
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {row.Current_cmp === '' ? (
          <span>{row.Current_cmp}</span>
        ) : (
          <div>
            <span>{row.Current_cmp}</span> |
            <div>


              <span>
                {value >= 0 ? <ArrowDropUpIcon fontSize="small" sx={{ color: 'green' }} /> : <ArrowDropDownIcon fontSize="small" sx={{ color: 'red' }} />}
              </span>
              <span style={{ color: value >= 0 ? 'green' : 'red' }}>{`${Math.abs(value)}(${percentDifference}%)`}</span>
            </div>
          </div>
        )}
      </div>
    )
  }

  // handle calculation of margin
  const marginCalculate =(row)=>{
     let margin = row.lot * row.margin
return(
     <div style={{ textAlign: 'right', color: 'blue' }} >
                                            {margin}
                                            {console.log("value", margin)}
                                            <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handleMarginOpenDialog(row)}>
                                              <Tooltip title={margin === '' || margin === null ? "Enter Margin" : "Edit Margin"} placement="right">
                                                {margin === '' || margin === null ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                              </Tooltip>
                                            </span>
                                          </div>
 ) 
  }

  // handle remove row from table dialog
  const handleremove = (row) => {
    setDelSelectedRecord(row);
    SetRemoveAlert(true);
  }

  // handle close remove submit
  const handleremoveRow = async () => {
    try {
      if (!DelSelectedRecord || !DelSelectedRecord.id) {
        setAlertMessage("Invalid record selected for removal.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
        return;
      }

      SetRemoveAlert(false);
      console.log("DelSelectedRecord:", DelSelectedRecord.id);

      const response = await fetch(`${BASE_URL}/RemoveMCXRow/${DelSelectedRecord.id}`, {
        method: "PUT",
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const res = await response.json();

      if (res.success === true) {
        updateSLchange();
        setAlertMessage(res.message || "Row removed successfully.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
      } else {
        setAlertMessage(res.message || "Failed to remove the row.");
        setshowAlert(true);
        setTimeout(() => {
          setshowAlert(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Error removing row:", error);
      setAlertMessage(error.message || "An error occurred while removing the row.");
      setshowAlert(true);
      setTimeout(() => {
        setshowAlert(false);
      }, 3000);
    }
  };

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #23499E",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  
  const handleChange = (event) => {
    event.preventDefault();
    // console.log("event.target.checked", event.target.checked);
    setChecked(event.target.checked);
  };



  return (
    <div className='mcxtable'>

      <h6>{heading}</h6>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
            <TableHead >
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      textAlign: 'center',
                      minWidth: column.minWidth,
                      backgroundColor: '#23499E',
                      color: 'white',
                      zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                      left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined

                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Record
                .slice(startIndex, endIndex)
                .map((row, index) => {
                  const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
                  // console.log("isNewRecord",isNewRecord)
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              position: 'sticky',
                              backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                              zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                              left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined
                            }}
                            class="table-cell-screenerTab"
                            key={column.id}
                            align={column.align}
                          >
                            {column.id === "S.No"
                              ? index + 1
                              : column.id === 'SignalType'
                                ? <div style={{ color: 'blue', fontWeight: '600', cursor: 'pointer' }} onClick={() => hyperLinkStockName(row)}>
                                  {value}
                                </div>
                                : column.id === 'SignalStopLoss'
                                  ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                    {value.toFixed(2)}
                                  </div>
                                  : column.id === "datetime"
                                    ? formatDateTime(row)
                                    : column.id === "Expiry"
                                      ? formatExpiry(row)
                                      : column.id === "Current_cmp"
                                        ? calCurrComp(row)
                                        : column.id === 'lot'
                                          ? <div style={{ textAlign: 'right', color: 'blue' }} >
                                            {value}
                                            {console.log("value", value)}
                                            <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handlelotOpenDialog(row)}>
                                              <Tooltip title={value === '' || value === null ? "Enter Lot Target" : "Edit Lot Target"} placement="right">
                                                {value === '' || value === null ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                              </Tooltip>
                                            </span>
                                          </div>
                                          : column.id === 'margin'
                                          ? marginCalculate(row)
                                          : column.id === 'Remove'
                                            ? <div>
                                              <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }}
                                                onClick={() => handleremove(row)}
                                              >
                                                <Tooltip title={"Remove row"} placement="right">
                                                  <HighlightOffIcon sx={{ width: 20, height: 20 }} />
                                                </Tooltip>
                                              </span>
                                            </div> : value
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={Record.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>


      <h6>Automatic Generated Signals</h6>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer>
          <Table style={{ margin: 0 }} stickyHeader aria-label="sticky table">
            <TableHead >
              <TableRow>
                {columns1.map((column, index) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      textAlign: 'center',
                      minWidth: column.minWidth,
                      backgroundColor: '#23499E',
                      color: 'white',
                      zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 20 : 5,
                      left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined

                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {Record1
                .slice(startIndex, endIndex)
                .map((row, index) => {
                  const isNewRecord = newRecords.some(newRecord => newRecord.id === row.id);
                  // console.log("isNewRecord",isNewRecord)
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                      {columns1.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              position: 'sticky',
                              backgroundColor: RecordColor == 1 ? '#fff' : isNewRecord ? 'lightgreen' : '#fff',
                              zIndex: column.id === "S.No" || column.id === "SignalType" || column.id === "Remove" ? 10 : 1,
                              left: column.id === "S.No" ? 40 : column.id === "SignalType" ? 80 : column.id === "Remove" ? 0 : undefined
                            }}
                            class="table-cell-screenerTab"
                            key={column.id}
                            align={column.align}
                          >
                            {column.id === "S.No"
                              ? index + 1
                              : column.id === 'SignalType'
                                ? <div style={{ color: 'blue', fontWeight: '600', cursor: 'pointer' }} onClick={() => hyperLinkStockName(row)}>
                                  {value}
                                </div>
                                : column.id === 'SignalStopLoss'
                                  ? <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => handleStockLossChange(row)}>
                                    {value.toFixed(2)}
                                  </div>
                                  : column.id === "datetime"
                                    ? formatDateTime(row)
                                    : column.id === "Expiry"
                                      ? formatExpiry(row)
                                      : column.id === "Current_cmp"
                                        ? calCurrComp(row)
                                        : column.id === 'lot'
                                          ? <div style={{ textAlign: 'right', color: 'blue' }} >
                                            {value}
                                            {console.log("value", value)}
                                            <span style={{ color: '#454545', cursor: 'pointer', marginLeft: '10px', marginRight: '5px' }} onClick={() => handlelotOpenDialog(row)}>
                                              <Tooltip title={value === '' || value === null ? "Enter Lot Target" : "Edit Lot Target"} placement="right">
                                                {value === '' || value === null ? <AddCircleOutlineIcon sx={{ width: 13, height: 13 }} /> : <ModeEditOutlineOutlinedIcon sx={{ width: 15, height: 15 }} />}
                                              </Tooltip>
                                            </span>
                                          </div>
                                          : column.id === 'margin'
                                          ? marginCalculate(row)
                                          : column.id === 'Remove'
                                            ?
                                            <div style={{display:"flex",flexDirection:'row',justifyContent:'space-around'}}>
                                                 <Tooltip title={"Remove row"} placement="right">
                                                  <HighlightOffIcon sx={{ width: 20, height: 20 }} onClick={() => {handleremove(row)}}/>
                                                </Tooltip>
                                             <Tooltip title={"SL Trigger Close"} placement="right">
                                              <SendIcon sx={{ width: 20, height: 20 }} onClick={()=>{handleRecordSend(row)}} />
                                            </Tooltip>
                                             
                                           </div>  : value
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={Record1.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      {/* dialog for book profit and book loss */}
      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {BookPorL >= 0 ? 'Book Profit' : 'Book Loss'}
        </DialogTitle>
        <DialogContent style={{ width: '350px' }}>
          <div className="Authmain">
            <div className="Authcontent">

              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <h4>CMP:</h4>
                <div className='cmp-value'>
                  <span>{cmp} {BookPorL >= 0 ? <ArrowDropUpIcon fontSize="large" color="success" /> : <ArrowDropDownIcon fontSize="large" sx={{ color: 'red' }} />}</span>
                  <span style={{ color: BookPorL >= 0 ? 'green' : 'red' }}>{BookPorL}</span>
                </div>
                <div style={{ width: '100%' }}>
                  <label htmlFor="withCommentery" style={{ marginRight: '10px' }}>With Commentary</label>
                  <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={checked}
                    onChange={handleChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                {selectedRecord.lot > 1?  
                <> {Errorshow ?
                  <span style={{ color: "red" }}>
                    {Errormessage}
                  </span>
                  : null}
                <div style={{width:'100%' ,display:'flex',flexDirection:'row',}}>
                 
                  <div>
                  <label htmlFor="availablelot" style={{ width:"100%", marginRight: '10px' }}>Available Lot</label>
                  <input
                    id="availablelot"
                    placeholder="Avilable Lot"
                    value={selectedRecord.lot}
                    disabled={true}
                  />
                  </div>
                   
                  <div>
                  <label htmlFor="booklot" style={{ width:"100%", marginRight: '10px' }}>Book Lot <span className='asterisk'>*</span></label>
                  <input
                    id="booklot"
                    placeholder="Book Lot"
                    value={bookLot}
                    onChange={(e) => handleBooklotChange(e)}
                  />
                  </div>
                </div>
                </>
                :null}
                <div style={{ width: '100%' }}>
                  <label htmlFor="Commentry" style={{ marginRight: '10px' }}>Commentary</label>
                  <textarea
                    id="inputField"
                    placeholder="Type a message"
                    value={commentrymessage}
                    onChange={(e) => setCommentryMessage(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={(e) => handleBookProfitOrLoss(e, BookPorL >= 0 ? 'Book Profit' : 'Close Position')}>
            {BookPorL >= 0 ? 'Book Profit' : 'Close Position'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* dialog for authencation */}
      <Dialog
        open={authenticationOpen}
        onClose={handleAuthenticationClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Authentication to change SL"}
          {"Authentication to change SL"}
        </DialogTitle>
        {loading ? (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 2,
            }}

          >
            <Loading />
          </div>
        ) : null}
        <form onSubmit={handleAuthSubmit}>
          <DialogContent style={{ width: '450px' }}>
            <div className="Authmain">
              <div className="Authcontent">
                {Errorshow ?
                  <span style={{ color: "red" }}>
                    {Errormessage}
                  </span>
                  : null}
                <div>
                  <p>Username :<span className='asterisk'>*</span></p>
                  <input value={authdata.username} type="email" id="username" name="username" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter username" />
                </div>

                {showInvalidPasswordAlert && (
                  <span>
                    Please enter a valid password. Passwords must be at least 8
                    characters long and contain at least one letter, one digit, and
                    may include special characters.
                  </span>
                )}
                <div>
                  <p>Password :<span className='asterisk'>*</span></p>
                  <input value={authdata.password} type="password" id="password" name="password" required onChange={handleAuthChange} autocomplete="off" placeholder="Enter Password" />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button className='btn-cancel' onClick={handleAuthenticationClose}>Cancel</Button>

            <input type="submit" value="Submit" className='btn-submit'
              style={{ width: '70px', borderRadius: '5px', cursor: authdata.username === '' || authdata.password === '' ? 'not-allowed' : 'pointer' }}
              disabled={authdata.username === '' || authdata.password === ''} />
          </DialogActions>
        </form>
      </Dialog>

      {/* dialog for sl change  */}

      <Dialog
        open={SLEditOpen}
        onClose={handleSLEditClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Stop Loss"}
        </DialogTitle>
        <DialogContent style={{ width: '450px' }}>
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Stop Loss:<span className='asterisk'>*</span></p>
                <input value={newsl} type="number" id="sl" name="sl" required onChange={handleSLChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleSLEditClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleSLChangeSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      {/* dialog for Lot change */}
      
      <Dialog
        open={LotEditOpen}
        onClose={handleLotClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter New Second Target"}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Lot Size:<span className='asterisk'>*</span></p>
                <input value={newLot} type="number" id="lot" name="lot" required onChange={handlelotChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleLotClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleLotSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* edit margin dialog or add margin dialog */}
      <Dialog
        open={MarginEditOpen}
        onClose={handleMarginClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='screener-bookprofit'
      >
        <DialogTitle id="alert-dialog-title">
          {"Enter Margin"}
        </DialogTitle>
        <DialogContent className='dialog-content' >
          {loading ? (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 2,
              }}

            >
              <Loading />
            </div>
          ) : null}

          <div className="Authmain">
            <div className="Authcontent">
              {Errorshow ?
                <span style={{ color: "red" }}>
                  {Errormessage}
                </span>
                : null}
              <div className="popup-slvalue">
                <p>Margin:<span className='asterisk'>*</span></p>
                <input value={newMargin} type="number" id="margin" name="margin" required onChange={handleMarginChange} />
              </div>

            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className='btn-cancel' onClick={handleMarginClose}>cancel</Button>
          <Button className='btn-yes' onClick={handleMarginSubmit} autoFocus>
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={RemoveAlert}
        onClose={() => SetRemoveAlert(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ color: "#2380DE", width: '100%', textAlign: 'center', display: 'block' }} id="alert-dialog-title">
          {"Confirmation "}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure, you want to remove row
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="btn-cancel"
            variant="outlined"
            color="error"
            onClick={() => SetRemoveAlert(false)}
          >
            No
          </Button>
          <Button className="btn-submit"
            variant="outlined"
            color="success"
            onClick={handleremoveRow}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>


      

{/* Dialog to show error alert */}
      <Dialog
        open={showAlert}
        onClose={() => { setshowAlert(false) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <p style={{ color: "green", padding: '10px 30px 10px 30px', margin: 0 }}>{AlertMessage}</p>
      </Dialog>
    </div>
  )
}

export default McxTable